/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Move a document into a folder or back to root.
 * @export
 * @interface MoveDocumentToFolderRequest
 */
export interface MoveDocumentToFolderRequest {
    /**
     * ID of the document to move
     * @type {number}
     * @memberof MoveDocumentToFolderRequest
     */
    documentId: number;
    /**
     * Target folder ID. Null to move to root.
     * @type {number}
     * @memberof MoveDocumentToFolderRequest
     */
    folderId: number | null;
}

/**
 * Check if a given object implements the MoveDocumentToFolderRequest interface.
 */
export function instanceOfMoveDocumentToFolderRequest(value: object): value is MoveDocumentToFolderRequest {
    if (!('documentId' in value) || value['documentId'] === undefined) return false;
    if (!('folderId' in value) || value['folderId'] === undefined) return false;
    return true;
}

export function MoveDocumentToFolderRequestFromJSON(json: any): MoveDocumentToFolderRequest {
    return MoveDocumentToFolderRequestFromJSONTyped(json, false);
}

export function MoveDocumentToFolderRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MoveDocumentToFolderRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'documentId': json['documentId'],
        'folderId': json['folderId'],
    };
}

export function MoveDocumentToFolderRequestToJSON(json: any): MoveDocumentToFolderRequest {
    return MoveDocumentToFolderRequestToJSONTyped(json, false);
}

export function MoveDocumentToFolderRequestToJSONTyped(value?: MoveDocumentToFolderRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'documentId': value['documentId'],
        'folderId': value['folderId'],
    };
}

